import { Flex } from 'antd';

interface CollectionWidgetContainerProps {
  slot: {
    hotcash: React.ReactNode;
    lateCash: React.ReactNode;
    lateAgronomist: React.ReactNode;
    todayActivity: React.ReactNode;
  };
}

// Note: Slot pattern is used here to avoid prop drilling and to keep the layout styling separate
const CollectionWidgetContainer = ({
  slot,
}: CollectionWidgetContainerProps) => {
  return (
    <Flex className="collection-widget-container" gap={16} wrap="wrap">
      <Flex vertical gap={16} className="widget-start">
        {slot.hotcash}
        <Flex gap={16} className="h-100" wrap="wrap">
          {slot.lateCash}
          {slot.lateAgronomist}
        </Flex>
      </Flex>
      <Flex vertical className="widget-end h-100">
        {slot.todayActivity}
      </Flex>
    </Flex>
  );
};

export default CollectionWidgetContainer;
